import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom } from 'rxjs';
import {
    getNameDay,
    getTekDay,
    getTime,
} from 'src/app/components/application/global.function';
import { IHistoryEvents } from 'src/app/interfaces/history.interface';
import { HistoryItemComponent } from 'src/app/modals/history-item/history-item.component';
import { HistoryPdfModal } from 'src/app/modals/history-pdf-modal/history-pdf.component';
import { ConfigService } from 'src/app/services/application/config.service.';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { LoadService } from 'src/app/services/application/load.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { DicomViewModalComponent } from '../../dicom-view-modal/dicom-view-modal.component';

@Component({
    selector: 'app-visit-card',
    templateUrl: './visit-card.component.html',
    styleUrls: ['./visit-card.component.scss'],
})
export class VisitCardComponent {
    @Input() visit!: IHistoryEvents;
    @Input() gridTemplateColumns!: string;
    pdfImageURL = 'assets/img/svg/pdf-view.svg';
    txtPhone = '8 800 555 666';
    showFilials = true;
    pdfLoading = false;

    constructor(
        private modalService: NgbModal,
        private dialog: MatDialog,
        private http: HttpNewService,
        private alert: AlertService,
        private configS: ConfigService,
        private load: LoadService
    ) {
        if (
            load.configData.pages.services &&
            load.configData.pages.services.WEB_LK_SERVICES_INFO
        ) {
            this.txtPhone = load.configData.pages.services.WEB_LK_SERVICES_INFO;
            this.showFilials = Boolean(
                load.configData.pages.history.showFilials
            );
        }
    }

    historyItem(id: number, tp: string) {
        const dialogRef = this.dialog.open(HistoryItemComponent, {
            width: 'auto',
            height: 'auto',
            closeOnNavigation: true,
            data: { type: tp, id: id },
        });
    }

    async gotToDownload(id: number, tp: string, $event: MouseEvent) {
        $event.stopPropagation();
        this.pdfLoading = true;

        const statePdf: number = this.load.configData.pages.history.PDFButtonState ?? 0;
        let statePdfFull: number = statePdf ? 1 : 0;

        switch (statePdfFull) {
            case 1:
                try {
                    const res = await lastValueFrom(
                        this.http.get(
                            `/history/events/item/visitpdf/${tp}/${id}`,
                            null,
                            false
                        )
                    );
                    this.dialog.open(HistoryPdfModal, {
                        width: 'auto',
                        height: 'auto',
                        closeOnNavigation: true,
                        data: res,
                    });
                    this.pdfLoading = false;
                } catch (e) {
                    this.alert.error('Ошибка загрузки');
                    this.pdfLoading = false;
                }
                break;
            default:
                try {
                    const res:
                        | string
                        | { text: string; link_or_html_flag: string } =
                        await lastValueFrom(
                            this.http.get(
                                this.getDownloadUrlForPDF(id, tp),
                                null,
                                false
                            )
                        );
                    if (
                        typeof res === 'object' &&
                        res.link_or_html_flag === 'link'
                    ) {
                        lastValueFrom(
                            this.http.post(
                                '/history/events/visit/api',
                                { url: res.text },
                                true
                            )
                        )
                            .then((pdf) => {
                                return this.printPdf(pdf);
                            })
                            .catch((err) => {
                                this.alert.error(`Ошибка ${err.message}`);
                            });
                    } else {

                        return this.printPdf(res as string);
                    }
                } catch (error) {
                    console.log(error);
                    this.alert.error('Ошибка загрузки');
                } finally {
                    this.pdfLoading = false;
                }
        }
    }

    getDownloadUrlForPDF(id: number, tp: string) {
        return `/history/events/item/${tp}/${id}.pdf`;
    }

    openDicomModal(
        accessionNumber: string,
        studyDate: string,
        studyInstanceUID: string,
        e: MouseEvent
    ) {
        e.stopPropagation();
        const modal = this.modalService.open(DicomViewModalComponent);
        modal.componentInstance.accessionNumber = accessionNumber;
        modal.componentInstance.studyDate = studyDate
            .match(/(\d{0,4})(\d{0,2})(\d{0,2})/)
            ?.splice(1, 4)
            .reverse()
            .join('.');
        modal.componentInstance.studyInstanceUID = studyInstanceUID;
    }

    async downloadDicomArchive(studyID: string, e: MouseEvent) {
        e.stopPropagation();
        this.http.get(this.getDownloadUrl(studyID), null);
    }

    getDownloadUrl(studyIUID: string): string {
        return (
            this.configS.getValue('hostBackend') +
            `/history/visit/dicom/download?studyIUID=${studyIUID}`
        );
    }

    stopPropagation(e: MouseEvent) {
        e.stopPropagation();
    }

    getTekDay(dt: Date): string {
        return getTekDay(dt);
    }

    getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    getTime(dt: Date): string {
        return getTime(dt);
    }

    private printPdf(blob: string): void {
        const cleanBase64 = blob.replace(/^data:application\/pdf;base64,/, '');
        const binaryString = atob(cleanBase64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const file = new Blob([bytes], {
            type: 'application/pdf',
            endings: 'native'
        });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.type = 'application/pdf';
        link.download = 'document.pdf'
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link );
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(fileURL), 60_000);
    }
}